import React, { useCallback, useMemo, useState } from 'react';
import { Container, Graphics } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { jackPotStore } from '../../../../store/jackPotStore';

import { isMobile } from '../../../../core/helpers/isMobile';
import { getGameImages } from '../../../../core/helpers/getGameImages';

import JackPotInfoItem from './jackPotInfoItem';
import JackPotInfoPopup from '../jackPotInfoPopup';
import { exchangeAmount } from '../../../../core/helpers/exchangeAmountByRate';
import { menuSectionStore } from '../../../../store/menuSectionStore';

const JackPotInfo = observer(({ containerConfig }) => {
  const [selectedJackpotId, setSelectedJackpotId] = useState(null);
  const [graphicsVisible, setGraphicsVisible] = useState(false);

  const { jackpotWinnerInfo, jackpotAmounts } = jackPotStore;
  const {
    JackPotInput,
    jackPotPikes,
    jackPotHeart,
    jackPotClover,
    jackPotDiamond,
    JackPotInputSmall,
  } = useMemo(() => {
    return getGameImages();
  }, []);

  const jackPotItems = useMemo(
    () => [
      {
        x: isMobile() ? 3.5 : 0,
        id: 1,
        type: 'clubAmount',
        iconImage: jackPotClover,
        inputImage: isMobile() ? JackPotInputSmall : JackPotInput,
        containerName: 'JackPotInfoClubContainer',
      },
      {
        x: isMobile() ? 121 : 230,
        id: 2,
        type: 'diamondAmount',
        iconImage: jackPotDiamond,
        inputImage: isMobile() ? JackPotInputSmall : JackPotInput,
        containerName: 'JackPotInfoDiamondContainer',
      },
      {
        x: isMobile() ? 238.5 : 774,
        id: 3,
        type: 'heartAmount',
        iconImage: jackPotHeart,
        inputImage: JackPotInput,
        containerName: 'JackPotInfoHeartContainer',
      },
      {
        x: isMobile() ? 389 : 1003,
        id: 4,
        type: 'spadeAmount',
        iconImage: jackPotPikes,
        inputImage: JackPotInput,
        containerName: 'JackPotInfoSpadeContainer',
      },
    ],
    [JackPotInput, JackPotInputSmall, jackPotClover, jackPotDiamond, jackPotHeart, jackPotPikes]
  );

  const handlePointerOver = useCallback((e) => {
    setGraphicsVisible(true);
    setSelectedJackpotId(e.target.id);
  }, []);

  const handlePointerLeave = useCallback(() => {
    if (isMobile()) {
      setGraphicsVisible(false);
    }
    setSelectedJackpotId(null);
  }, []);

  const jackpotWinnerInfoById = useMemo(() => {
    return Object.values(jackpotWinnerInfo).find((el) => el.jackpotCard === selectedJackpotId);
  }, [jackpotWinnerInfo, selectedJackpotId]);

  return (
    <Container
      {...containerConfig}
      name='JackPotInfoContainer'
      visible={!menuSectionStore.isShowMenuPopup}
    >
      <Graphics
        pointerup={handlePointerLeave}
        interactive
        visible={isMobile() ? graphicsVisible : false}
        draw={(g) => {
          g.clear();
          g.beginFill(0xff700b);
          g.alpha = 0;
          g.drawRect(0, 40, 540, 910);
        }}
      />
      {jackPotItems.map((item) => {
        const { x, type, id, iconImage, inputImage, containerName } = item;
        return (
          <JackPotInfoItem
            x={x}
            id={id}
            key={id}
            iconImage={iconImage}
            inputImage={inputImage}
            amount={exchangeAmount(jackpotAmounts[type])}
            containerName={containerName}
            selectedJackpotId={selectedJackpotId}
            handlePointerOver={handlePointerOver}
            handlePointerLeave={handlePointerLeave}
          />
        );
      })}
      {jackpotWinnerInfoById && (
        <JackPotInfoPopup
          y={isMobile() ? 35 : 50}
          x={jackPotItems.find((item) => item.id === selectedJackpotId).x}
          selectedJackpotId={selectedJackpotId}
          jackpotWinnerInfoById={jackpotWinnerInfoById}
        />
      )}
    </Container>
  );
});

export default JackPotInfo;
